import type { TFunction } from "i18next"
import React, { createContext, useContext } from "react"

import { useAppContext } from "@contexts/app_context"
import useToggle from "@hooks/use_toggle"
import i18next from "@utils/localization"

type ScriptsPageContextProps = {
  translate: TFunction<"translation", undefined>
  isLeftDrawerOpen?: boolean
  toggleIsLeftDrawerOpen?: () => void
}

const defaultValues: ScriptsPageContextProps = {
  translate: i18next.t
}

const ScriptsPageContext = createContext(defaultValues)

export function ScriptsPageContextProvider(props: {
  children: React.ReactNode | React.ReactNode[]
}) {
  const { translate } = useAppContext()
  const [isLeftDrawerOpen, toggleIsLeftDrawerOpen] = useToggle(true)
  return (
    <ScriptsPageContext.Provider
      value={{
        ...defaultValues,
        translate,
        isLeftDrawerOpen,
        toggleIsLeftDrawerOpen
      }}
    >
      {props.children}
    </ScriptsPageContext.Provider>
  )
}

export function useScriptsPageContext() {
  const context = useContext(ScriptsPageContext)
  if (context === undefined) {
    throw new Error("UserPage Context Error")
  }
  return context
}
